import { areObjectsShallowEqual } from "./areObjectsShallowEqual";

export function areNullableObjectsShallowEqual<T extends object>(a?: T | null, b?: T | null): boolean {
  if (a == null || b == null) {
    return a === b;
  } else {
    return areObjectsShallowEqual(a, b);
  }
}
